import { httpCreate } from './http';

const http = httpCreate('/srv/activityScreen');

export const activityScreen = {
	// 获取大屏互动设置信息
	getScreenInfo(activityId) {
		return http.get(`getScreenInfo/${activityId}`);
    },
    // 修改大屏互动信息
    saveScreenInfo(activityId,data) {
        return http.post(`save/${activityId}`,data);
    },
    // 大屏校验密码
	setScreenPassword(activityId) {
		return http.post(`/setScreenPassword/${activityId}`);
	},
};